export default __webpack_public_path__ + "static/masthead_bg_mobile_france-dc2d7c1771dc2c39872614f34600c0b2.jpg";